import styled from '@emotion/styled';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';

export const MessageBoxBtnWrapper = styled(Button, { label: 'MessageBoxBtnWrapper' })`
    display: block;
    margin: 0 auto !important;
`;
